/**
 * True when the logged-in account is the dev tester `player1`.
 * Accepts username string (e.g. WareEffort route) or user object from App.
 */
export function isPlayer1DevUser(user) {
  if (typeof user === 'string') {
    return user === 'player1';
  }
  if (user != null && typeof user === 'object') {
    return user.username === 'player1';
  }
  return false;
}
